<template>
  <div class="container">
    <div class="title">
      <img src="../../src/assets/images/memberInfo/logo.png" alt="" />
    </div>
    <div class="contentBox cyjjbox">
      <div class="cyjjItem" v-for="(item, ind) in cyjjList" :key="ind" @click="toDetail(item)">
        <img :src="item.illustration" alt="" />
        <div class="name">{{ item.fName }}</div>
        <div class="desc" :title="item.digest">{{ item.digest }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '../../apis/index'

export default {
  name: "MemberInfo",
  components: {
    // CarouselCopy,
  },
  data() {
    return {
      cyjjList: [],
      currentPage: 1,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      pages: 0,
    };
  },
  mounted() {
    const currentRouter = {
      name: '成员简介',
      path: '/memberInfo'
    }

    localStorage.setItem('currentRouter', JSON.stringify(currentRouter));
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.$http.get(`${API.getForum}?type=2&pageNum=${this.pageNum}&pageSize=10`).then(res => {
        console.log(res.data.data)
        this.cyjjList = res.data.data.list
      })
    },
    toDetail(item) {
      const params = {
        fId: item.fId
      }
      console.log(item)
      this.$router.push({
        path: '/memberDetail',
        query: {
          item: JSON.stringify(params)
        },
      });
    }
  }
};
</script>
<style scoped>
.container {
  width: 1000px;
  padding: 0 0 90px;
}

.contentBox {
  width: 100%;
  margin-top: 20px;
}

.cyjjbox {
  display: flex;
  flex-wrap: wrap;
}

.cyjjItem {
  width: 210px;
  height: 366px;
  background: url("../../src/assets/images/memberInfo/div.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 40px;
  padding: 21px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 46px;
  cursor: pointer;
}

.cyjjItem img {
  width: 180px;
}

.cyjjItem .name {
  margin: 16px auto 8px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #391603;
}

.cyjjItem .desc {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #553827;
  line-height: 20px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>